import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const FAQ = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What is Wacation On Wheels?",
      answer: "Wacation On Wheels is an elegant caravan and RV rental service that enables you to enjoy your vacations in a whole new way. Bringing premium caravans to you at an affordable rate is our goal. With the flexible itineraries and prompt service, we intend to make your vacation memorable as well as enjoyable with Wacation On Wheels."
    },
    {
      question: "What is the Price?",
      answer: "The price starts from Rs.2500 per day per person. It varies as per the size of the caravan and group discount. For the exact cost please contact us."
    },
    {
      question: "What is included in Price?",
      answer: "The price includes caravan rental along with driver and helper, diesel charges, toll charges and cooking utensils."
    },
    {
      question: "Are the parking locations safe?",
      answer: "Caravan parking locations are in association with resorts or local residents and are completely safe. However, necessary precautions should always be taken including, locking doors when leaving the caravan, being cautious about strangers, informing others in the group when going out, and keeping track of all your belongings all the time."
    },
    {
      question: "Can I rent on per kilometer basis?",
      answer: "Yes, you can rent the caravan with the driver on per kilometer basis. For details please contact us on +91 83 808 66 111 or drop us an email."
    },
    {
      question: "Are there specific parking locations for the caravan?",
      answer: "Yes, most of the parking locations are in the local resort premises, considering the safety. All the details will be provided on booking."
    },
    {
      question: "Can I drive the caravan myself if I have HV license?",
      answer: "No, our insurance requires our drivers at the wheel at all times. We are working to deploy caravans you can drive yourself."
    },
    {
      question: "Have the driver and helper undergone a background check?",
      answer: "Yes, all our staff has undergone security checks."
    },
    {
      question: "What are the food options?",
      answer: "Caravans have gas and a full set of utensils to cook. You can make any trip memorable by cooking together, having a barbecue or trying some local fare in the best restaurants nearby."
    },
    {
      question: "Will the helper cook for me?",
      answer: "We recommend you do it yourself. But a helper may do it for you if you are nice to him, say please and offer some remuneration for the extra work :). Our helpers are not trained cooks so we cannot guarantee that you would like the meals."
    },
    {
      question: "Will I have phone connectivity (mobile signal)?",
      answer: "Phone connectivity is dependent on your carrier and the location. Some parking locations have limited signal, where GPS or Wi-Fi might not work. We suggest downloading online maps for offline use as far as possible."
    },
    {
      question: "Does the caravan have a TV and a music system?",
      answer: "Yes, all of our Caravans are integrated with LCD TV's and a music system."
    },
    {
      question: "Does the caravan have restroom/bathroom?",
      answer: "Yes, all our caravans have bathrooms with WC, wash basin and shower."
    },
    {
      question: "What happens if there is vehicle breakdown?",
      answer: "Breakdowns can happen, as with any means of transport. They will be dealt AS SOON AS POSSIBLE. Any days lost due to breakdowns will be added to the itinerary so as to complete the planned visits. Depending on the situation and need, alternate travel arrangements could be made to ensure pre-decided schedule is adhered to."
    }
  ];

  return (
    <section id="faq" className="section-padding bg-gradient-to-br from-primary-50 to-white">
      <div className="container-custom">
        <div ref={ref} className="max-w-4xl mx-auto">
          {/* Header */}
          <div className={`text-center mb-12 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-8'}`}>
            <span className="text-accent-600 font-semibold text-sm uppercase tracking-wide">
              Got Questions?
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-primary-800 mt-4">
              Frequently Asked 
              <span className="text-accent-600"> Questions</span>
            </h2>
            <p className="text-lg text-primary-600 mt-4 max-w-2xl mx-auto">
              Find answers to common questions about our caravan rental services
            </p>
          </div>

          {/* FAQ Items */}
          <div className={`space-y-4 transition-all duration-700 delay-200 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border border-primary-100 overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-primary-50 transition-colors"
                >
                  <h3 className="text-lg font-semibold text-primary-800 pr-4">
                    {faq.question}
                  </h3>
                  <div className="text-accent-500 text-xl flex-shrink-0">
                    {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                  </div>
                </button>
                
                <div
                  className={`transition-all duration-300 ease-in-out ${
                    openIndex === index
                      ? 'max-h-96 opacity-100'
                      : 'max-h-0 opacity-0'
                  } overflow-hidden`}
                >
                  <div className="px-6 pb-5 text-primary-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Contact CTA */}
          <div className={`mt-12 text-center transition-all duration-700 delay-400 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <p className="text-lg text-primary-600 mb-4">
              Still have questions? We're here to help!
            </p>
            <a
              href="#contact"
              className="inline-block px-8 py-3 bg-accent-500 text-white font-semibold rounded-full shadow-lg hover:bg-accent-600 hover:shadow-xl transition-all hover:-translate-y-1"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
